import { useState } from 'react'
import type { Project } from '../data/projectTypes'
import { connectedIssueTracker } from '../lib/agentConnection'
import IssueTrackerChatCard from './chat/IssueTrackerChatCard'
import './TestingSetup.css'
import './chat/chat.css'

export default function IssueTrackerSetup({ project, canEdit }: { project: Project; canEdit: boolean }) {
  const [trackerOpen, setTrackerOpen] = useState(false)
  const tracker = connectedIssueTracker(project)
  return <div className="agent-connection testing-settings">
    <p>Connect an issue tracker and QA will send new bug reports there for your team to resolve.</p>
    <section aria-labelledby="issue-tracker-title">
      <h2 id="issue-tracker-title">Issue tracker</h2>
      <p>{tracker ? `Connected to ${tracker.name}: ${tracker.destination}. QA sends new bug reports here.` : 'No issue tracker connected. Connect GitHub Issues, GitLab, Linear, Jira, or Asana.'}</p>
      <div className="testing-setup__actions">
        <button type="button" disabled={!canEdit} onClick={() => setTrackerOpen(true)}>
          {tracker ? 'Manage issue tracker' : 'Connect issue tracker'}
        </button>
      </div>
      {canEdit && trackerOpen && <div className="agent-connection__tracker">
        <IssueTrackerChatCard project={project} onClose={() => setTrackerOpen(false)} />
      </div>}
      {!canEdit && <p>A project member can connect an issue tracker.</p>}
    </section>
  </div>
}
